/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snippet_Your_TokenInputs */

const fr_snippet_your_token = /** @type {(inputs: Snippet_Your_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VOTRE_TOKEN`)
};

const en_snippet_your_token = /** @type {(inputs: Snippet_Your_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YOUR_TOKEN`)
};

/**
* | output |
* | --- |
* | "YOUR_TOKEN" |
*
* @param {Snippet_Your_TokenInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const snippet_your_token = /** @type {((inputs?: Snippet_Your_TokenInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snippet_Your_TokenInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snippet_your_token(inputs)
	return en_snippet_your_token(inputs)
});